import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Re-renders the current form page via a GET visit when a field changes, so
// the server can swap kind-specific fields (e.g. combo composition) without
// saving first. Typed values ride along as query params and prefill the
// rebuilt form; CSRF/method params are stripped since this is a plain GET.
export default class extends Controller {
  refresh() {
    const params = new URLSearchParams(new FormData(this.element))
    params.delete("authenticity_token")
    params.delete("_method")
    Turbo.visit(`${window.location.pathname}?${params.toString()}`)
  }
}
